import React from 'react'
import {
    KioskContent,
    KioskHeader,
    RecipeItem,
    RecipeTitle,
    RecipePoints,
    RecipePrice,
    RecipeComposition,
    RecipeLabels,
    RecipeLabel,
    EnergyKCal,
} from './style'
import styled from 'styled-components'

import LabelIcons from '../LabelIcons/LabelIcons'

// ;<img
//     src={`img/concept/${props.concept}/kiosk/${kioskPicture ||
//         props.name}/header.png`}
//     alt={props.name}
// />

const kiosk = props => {
    const {
        items = [],
        currency,
        kioskPicture,
        useCommercialName,
        hideMenuPrice,
        hideRecipePoints,
        hideEnergyKcal,
        showEnergyKcalByPortion,
        hideComposition,
        hideLabels,
        hideIntolerences,
        dataSource,
    } = props

    const formatPrice = item => {
        let priceInt, priceSup, winrest_price
        if (!item.price) {
            return []
        }

        if (item.currency === 'CHF') {
            priceInt = `${item.currency} ${item.price.replace('.', ',')}`
            priceSup = ''
            winrest_price = priceInt
        } else {
            if (item.price_currency && !!item.price_currency) {
                const priceRegex = /(\d+)[,|.](\d+)(.*)/
                const priceMatches = priceRegex.exec(item.price_currency)
                if (priceMatches) {
                    priceInt = priceMatches[1]
                    const decimals =
                        parseInt(priceMatches[2]) !== 0 ? priceMatches[2] : ''
                    priceSup = priceMatches[3].trim() + decimals
                }
            }
            if (item.price) {
                const priceArray = item.price.toString().split('.')
                priceInt = priceArray[0].toString() + item.currency || currency
                priceSup = priceArray[1]
                winrest_price = priceInt + priceSup
            }
        }
        console.log(item, priceInt, priceSup)

        return [winrest_price, priceInt, priceSup]
    }

    return (
        <KioskContent>
            <KioskHeader
                backgroundImage={`img/concept/${
                    props.concept
                }/kiosk/${kioskPicture || props.name}/header.png?_=9edb01b`}
            >
                {!useCommercialName && (
                    <span>
                        <img
                            src={`img/concept/${
                                props.concept
                            }/kiosk/${kioskPicture ||
                                props.name}/logo.png?_=9edb01b`}
                            alt={props.name}
                            onError={i => (i.target.style.display = 'none')}
                        />
                    </span>
                )}
            </KioskHeader>
            {useCommercialName && (
                <NameHeader>{props.displayName || props.name}</NameHeader>
            )}
            {items.map((item, index) => {
                if (!item.menu_board_label) {
                    return
                }

                const [winrest_price, priceInt, priceSup] = formatPrice(item)

                return (
                    <RecipeItem
                        key={index}
                        customStyle={item.produit_du_jour || ''}
                    >
                        {item.produit_du_jour === 'produit_neo' && (
                            <img
                                src={`img/neo.jpg`}
                                style={{ height: '46px', marginTop: '-31px' }}
                            />
                        )}
                        <RecipeTitle>
                            <span style={{ marginRight: '.6em' }}>
                                {item.menu_board_label}
                            </span>
                            {!hideLabels && item.label && (
                                <RecipeLabel
                                    src={`img/labels/${item.label}.png`}
                                    onError={i =>
                                        (i.target.style.display = 'none')
                                    }
                                />
                            )}
                            {!hideLabels && item.caracteristique_produit && (
                                <RecipeLabel
                                    src={`img/labels/${item.caracteristique_produit}.png`}
                                    onError={i =>
                                        (i.target.style.display = 'none')
                                    }
                                />
                            )}
                        </RecipeTitle>

                        <>
                            {!hideRecipePoints && !!item.price_point ? (
                                <RecipePoints
                                    // fullWidth={
                                    //     !item.price_currency && !winrest_price
                                    // }
                                    endPosition={
                                        hideMenuPrice ||
                                        (!item.price_currency && !winrest_price)
                                    }
                                >
                                    <span>{item.price_point}</span>
                                </RecipePoints>
                            ) : null}

                            {!hideMenuPrice &&
                            (!!item.price_currency || !!winrest_price) ? (
                                <RecipePrice>
                                    <span>
                                        {priceInt}
                                        <span>{priceSup}</span>
                                    </span>
                                </RecipePrice>
                            ) : null}
                        </>

                        {!hideComposition && !!item.composition ? (
                            <RecipeComposition>
                                {item.composition}
                            </RecipeComposition>
                        ) : null}

                        {!hideIntolerences && (
                            <LabelIcons
                                item={item}
                                size="24px"
                                dataSource={dataSource}
                            />
                        )}

                        {!hideEnergyKcal &&
                            (showEnergyKcalByPortion
                                ? !!item.energyKCalByPortion && (
                                      <EnergyKCal
                                          fullWidth={
                                              !item.price_currency &&
                                              !winrest_price
                                          }
                                      >
                                          <span>
                                              {item.energyKCalByPortion}
                                          </span>
                                      </EnergyKCal>
                                  )
                                : !!item.energyKCal && (
                                      <EnergyKCal
                                          fullWidth={
                                              !item.price_currency &&
                                              !winrest_price
                                          }
                                      >
                                          <span>
                                              {item.energyKCal}
                                              <sup
                                                  style={{
                                                      marginLeft: '0.2em',
                                                      fontSize: '0.6em',
                                                  }}
                                              >
                                                  100g
                                              </sup>
                                          </span>
                                      </EnergyKCal>
                                  ))}
                        {/* {item.allergens.length > 0 || item.label !== '' ? <div className={styles.labels}><LabelIcons allergens={item.allergens} label={item.label} size='24px' /></div> : null} */}
                    </RecipeItem>
                )
            })}
        </KioskContent>
    )
}

export default kiosk

export const NameHeader = styled.h2`
    color: ${_ => _.theme.recipe_type_font_color || _.theme.header_background};
    text-align: center;
    position: relative;
    ${({ mono }) => (mono ? '' : 'margin-top: 5px;')}

    margin-bottom: 30px;
    &:after {
        content: '';
        height: 1px;
        background-color: ${_ => _.theme.header_background};
        width: 100%;
        width: 80%;
        position: absolute;
        left: 10%;
        bottom: -7px;
    }
`
